import './community';
import './shop';
import './layout';

[...document.querySelectorAll('[data-href]')].forEach((href) => {
  href.addEventListener('click', () => navigate(href.dataset.href));
});

[...document.querySelectorAll('[data-submit]')].forEach((element) => {
  let parent = element.parentNode;

  while (parent) {
    if (parent.tagName === 'FORM') {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        parent.submit();
      });

      break;
    }

    parent = parent.parentNode;
  }
});

[...document.querySelectorAll('[data-button-confirm]')].forEach((element) => {
  console.log(element);
  element.addEventListener('click', (event) => {
    event.preventDefault();

    if (confirm(element.dataset.buttonConfirm)) {
      element.form.submit();
    }

    return false;
  });
});

function navigate(url) {
  window.open(url, url.match(new RegExp(`^${window.location.protocol}//${window.location.hostname}`)) ? '_parent' : '_blank');
}
